import { createLazyIconComponent } from "./utils/create-lazy-icon-component.js";
const importer = (style, size) => {
    switch (`${style}-${size}`) {
        case 'outlined-lg': return import('./icons/remove/outlined/Lg.js');
        case 'outlined-md': return import('./icons/remove/outlined/Md.js');
        case 'outlined-xl': return import('./icons/remove/outlined/Xl.js');
        case 'outlined-2xl': return import('./icons/remove/outlined/Xxl.js');
        default:
            throw new Error(`No icon found for ${style} ${size}`);
    }
};
export default createLazyIconComponent(importer);
//# sourceMappingURL=Remove.js.map